// Browser session cleanup for an account that disappeared without a sign-out.
// This helper only removes dictation records. Meeting takes are deliberately
// left available for the owner's next sign-in, and no recorder is retired.
export async function purgeRememberedDictation(owner, spool) {
  for (const meta of await spool.list(owner, 'dictation')) await spool.remove(meta.id);
}

/** Return the remembered owner whose dictation should be purged on session adoption. */
export function rememberedOwnerToPurge(rememberedOwner, currentOwner, previousOwner) {
  if (!rememberedOwner || rememberedOwner === currentOwner || rememberedOwner === previousOwner)
    return null;
  return rememberedOwner;
}
